import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";

export default function ({open, onClose}) {
    if (!open) return null;

    return <Modal
        modalConfig={
            new ModalConfig()
                .setHeight("80%")
                .setWidth("100%")
                .setOnClose(onClose)
                .setComponent((
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell variant="head" width={"20%"}>0 %</TableCell>
                                <TableCell>
                                    Non assujetti à la TVA (micro entreprise)
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head" width={"20%"}>10 %</TableCell>
                                <TableCell>
                                    Client particulier
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head" width={"20%"}>20 %</TableCell>
                                <TableCell>
                                    Client professionnel ou collectivité
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                ))
        }
    />
}